
export default {
  async asyncData({ $getContent }) {
    return {
      terms: await $getContent('terms', false),
    }
  },
  head: {
    title: 'Terms of Service',
  },
}
